// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.ct-grid {
  stroke: rgba(255, 255, 255, 0.2);
  stroke-width: 1px;
  stroke-dasharray: 2px;
}

.ct-series-a .ct-point,
.ct-series-a .ct-line,
.ct-series-a .ct-bar,
.ct-series-a .ct-slice-donut {
  stroke: rgba(255, 255, 255, 0.8);
}

.ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-label {
  color: rgba(255, 255, 255, 0.7);
}

.ct-chart-line .ct-label,
.ct-chart-bar .ct-label {
  display: block;
  display: flex;
}

.ct-label {
  fill: rgba(0, 0, 0, 0.4);
  line-height: 1;
}
html * {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  background-color: #eeeeee;
  color: #3c4858;
  margin: 0;
  font-family: Roboto, Helvetica, Arial, sans-serif;
  font-weight: 300;
  line-height: 1.5em;
}

blockquote footer:before,
blockquote small:before {
  content: "\\2014 \\00A0";
}

small {
  font-size: 80%;
}

h1 {
  font-size: 3em;
  line-height: 1.15em;
}

h2 {
  font-size: 2.4em;
}

h3 {
  font-size: 1.825em;
  line-height: 1.4em;
  margin: 20px 0 10px;
}

h4 {
  font-size: 1.3em;
  line-height: 1.4em;
}

h5 {
  font-size: 1.25em;
  line-height: 1.4em;
  margin-bottom: 15px;
}

h6 {
  font-size: 1em;
  text-transform: uppercase;
  font-weight: 500;
}

body {
  background-color: #eeeeee;
  color: #3c4858;
}

blockquote p {
  font-style: italic;
}

body,
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 300;
  line-height: 1.5em;
}

a {
  color: #9c27b0;
  text-decoration: none;
}

a:hover,
a:focus {
  color: #89229b;
  text-decoration: none;
}

legend {
  border-bottom: 0;
}

* {
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-tap-highlight-color: transparent;
}

*:focus {
  outline: 0;
}

a:focus,
a:active,
button:active,
button:focus,
button:hover,
button::-moz-focus-inner,
input[type="reset"]::-moz-focus-inner,
input[type="button"]::-moz-focus-inner,
input[type="submit"]::-moz-focus-inner,
select::-moz-focus-inner,
input[type="file"] > input[type="button"]::-moz-focus-inner {
  outline: 0 !important;
}

legend {
  margin-bottom: 20px;
  font-size: 21px;
}

output {
  padding-top: 8px;
  font-size: 14px;
  line-height: 1.42857;
}

label {
  font-size: 14px;
  line-height: 1.42857;
  color: #aaaaaa;
  font-weight: 400;
}

footer {
  padding: 15px 0;
}

footer ul {
  margin-bottom: 0;
  padding: 0;
  list-style: none;
}

footer ul li {
  display: inline-block;
}

footer ul li a {
  color: inherit;
  padding: 15px;
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  border-radius: 3px;
  text-decoration: none;
  position: relative;
  display: block;
}

footer ul li a:hover {
  text-decoration: none;
}

@media (max-width: 991px) {
  body,
  html {
    position: relative;
    overflow-x: hidden;
  }

  #bodyClick {
    height: 100%;
    width: 100%;
    position: fixed;
    opacity: 0;
    top: 0;
    left: auto;
    right: 260px;
    content: "";
    z-index: 9999;
    overflow-x: hidden;
  }
}
.fixed-plugin {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 300;
  line-height: 1.5em;
  position: fixed;
  top: 180px;
  right: 0;
  width: 64px;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1031;
  border-radius: 8px 0 0 8px;
  text-align: center;
  top: 120px;
  .badge-primary-background-color: #9c27b0;
}

.fixed-plugin .SocialMediaShareButton,
.fixed-plugin .github-btn {
  display: inline-block;
}

.fixed-plugin li > a,
.fixed-plugin .badge {
  transition: all 0.34s;
  -webkit-transition: all 0.34s;
  -moz-transition: all 0.34s;
  text-decoration: none;
}

.fixed-plugin .fa-cog {
  color: #ffffff;
  padding: 10px;
  border-radius: 0 0 6px 6px;
  width: auto;
}

.fixed-plugin .dropdown-menu {
  right: 80px;
  left: auto;
  width: 290px;
  border-radius: 0.1875rem;
  padding: 0 10px;
  position: absolute;
  color: rgba(0, 0, 0, 0.87);
  display: inline-block;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
  background: #fff;
  border-radius: 3px;
}

.fixed-plugin .fa-circle-thin {
  color: #ffffff;
}

.fixed-plugin .active .fa-circle-thin {
  color: #00bbff;
}

.fixed-plugin .dropdown-menu > .active > a,
.fixed-plugin .dropdown-menu > .active > a:hover,
.fixed-plugin .dropdown-menu > .active > a:focus {
  color: #777777;
  text-align: center;
}

.fixed-plugin img {
  border-radius: 0;
  width: 100%;
  height: 100px;
  margin: 0 auto;
}

.fixed-plugin .dropdown-menu li > a:hover,
.fixed-plugin .dropdown-menu li > a:focus {
  box-shadow: none;
}
.fixed-plugin .badge {
  border: 3px solid #ffffff;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  height: 23px;
  margin-right: 5px;
  position: relative;
  width: 23px;
  background-color: rgba(30, 30, 30, 0.97);
}

.fixed-plugin .badge.active,
.fixed-plugin .badge:hover {
  border-color: #00bbff;
}

.fixed-plugin .badge-purple {
  background-color: #9c27b0;
}

.fixed-plugin .badge-blue {
  background-color: #00bcd4;
}

.fixed-plugin .badge-green {
  background-color: #4caf50;
}

.fixed-plugin .badge-orange {
  background-color: #ff9800;
}

.fixed-plugin .badge-red {
  background-color: #f44336;
}

.fixed-plugin h5 {
  font-size: 14px;
  margin: 10px;
}
.fixed-plugin .dropdown-menu li {
  display: block;
  padding: 4px 0px;
  width: 25%;
  float: left;
}

.fixed-plugin li.adjustments-line,
.fixed-plugin li.header-title,
.fixed-plugin li.button-container {
  width: 100%;
  height: 50px;
  min-height: inherit;
  padding: 0px;
  text-align: center;
}

.fixed-plugin li.adjustments-line p {
  margin: 0;
}

.fixed-plugin li.adjustments-line div,
.fixed-plugin li.header-title div,
.fixed-plugin li.button-container div {
  margin-bottom: 5px;
}
.fixed-plugin li.header-title {
  height: 30px;
  line-height: 25px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
}

.fixed-plugin .adjustments-line p {
  float: left;
  display: inline-block;
  margin-bottom: 0;
  font-size: 1em;
  color: #3c4858;
}

.fixed-plugin .adjustments-line a {
  color: transparent;
}

.fixed-plugin .adjustments-line a .badge-colors {
  position: relative;
  top: -2px;
}

.fixed-plugin .adjustments-line a a:hover,
.fixed-plugin .adjustments-line a a:focus {
  color: transparent;
}
.fixed-plugin .adjustments-line .dropdown-menu > li.adjustments-line > a {
  padding-right: 0;
  padding-left: 0;
  border-bottom: 1px solid #ddd;
  border-radius: 0;
  margin: 0;
}

.fixed-plugin .dropdown-menu > li > a.img-holder {
  font-size: 16px;
  text-align: center;
  border-radius: 10px;
  background-color: #fff;
  border: 3px solid #fff;
  padding-left: 0;
  padding-right: 0;
  opacity: 1;
  cursor: pointer;
  display: block;
  max-height: 100px;
  overflow: hidden;
  padding: 0;
}

.fixed-plugin .dropdown-menu > li > a.img-holder img {
  margin-top: auto;
}
.fixed-plugin .dropdown-menu > li:hover > a.img-holder,
.fixed-plugin .dropdown-menu > li:focus > a.img-holder {
  border-color: rgba(0, 187, 255, 0.53);
}

.fixed-plugin .dropdown-menu > .active > a.img-holder,
.fixed-plugin .dropdown-menu > .active > a.img-holder {
  border-color: #00bbff;
  background-color: #ffffff;
}
.fixed-plugin .dropdown .dropdown-menu {
  transform: translateY(-15%);
  top: 27px;
  opacity: 0;
  transform-origin: 0 0;
  display: none;
}

.fixed-plugin .dropdown .dropdown-menu:before {
  border-bottom: 0.4em solid transparent;
  border-left: 0.4em solid rgba(0, 0, 0, 0.2);
  border-top: 0.4em solid transparent;
  right: -16px;
  top: 46px;
}
.fixed-plugin .dropdown .dropdown-menu:after {
  border-bottom: 0.4em solid transparent;
  border-left: 0.4em solid #ffffff;
  border-top: 0.4em solid transparent;
  right: -16px;
}

.fixed-plugin .dropdown .dropdown-menu:before,
.fixed-plugin .dropdown .dropdown-menu:after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 46px;
  width: 16px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
}

.fixed-plugin .dropdown.show .dropdown-menu {
  display: block;
  visibility: visible;
  opacity: 1;
  transform: translateY(-13%);
  transform-origin: 0 0;
}
.fixed-plugin.rtl-fixed-plugin {
  right: auto;
  left: 0px;
  border-radius: 0 8px 8px 0;
}
.fixed-plugin.rtl-fixed-plugin .dropdown-menu {
  right: auto;
  left: 80px;
}
* {
  letter-spacing: normal !important;
}


.bgLoader{
  background-color: rgba(254, 251, 251, .7);
  position: absolute;
  padding-top: 40px;
  inset: 0 0 0 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/material-dashboard-react.css"],"names":[],"mappings":";AACA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;EAIE,uBAAuB;EAIvB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;EAKd,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,SAAS;EACT,iDAAiD;EACjD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;EAOE,uDAAuD;EACvD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mDAAmD;EACnD,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;;;;;;;;EAWE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;;IAEE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,UAAU;IACV,MAAM;IACN,UAAU;IACV,YAAY;IACZ,WAAW;IACX,aAAa;IACb,kBAAkB;EACpB;AACF;AACA;EACE,uDAAuD;EACvD,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,QAAQ;EACR,WAAW;EACX,8BAA8B;EAC9B,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;EACrB,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;;;EAGE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;;EAEE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;AACA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EAKE,2BAA2B;EAC3B,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,mCAAmC;EACnC,YAAY;EACZ,SAAS;AACX;AACA;EACE,sCAAsC;EACtC,gCAAgC;EAChC,mCAAmC;EACnC,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;EAKV,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,iCAAiC;AACnC;;;AAGA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":["\n.ct-grid {\n  stroke: rgba(255, 255, 255, 0.2);\n  stroke-width: 1px;\n  stroke-dasharray: 2px;\n}\n\n.ct-series-a .ct-point,\n.ct-series-a .ct-line,\n.ct-series-a .ct-bar,\n.ct-series-a .ct-slice-donut {\n  stroke: rgba(255, 255, 255, 0.8);\n}\n\n.ct-label.ct-horizontal.ct-end {\n  -webkit-box-align: flex-start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: flex-start;\n  align-items: flex-start;\n  -webkit-box-pack: flex-start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  text-anchor: start;\n}\n\n.ct-label {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.ct-chart-line .ct-label,\n.ct-chart-bar .ct-label {\n  display: block;\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n}\n\n.ct-label {\n  fill: rgba(0, 0, 0, 0.4);\n  line-height: 1;\n}\nhtml * {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\nbody {\n  background-color: #eeeeee;\n  color: #3c4858;\n  margin: 0;\n  font-family: Roboto, Helvetica, Arial, sans-serif;\n  font-weight: 300;\n  line-height: 1.5em;\n}\n\nblockquote footer:before,\nblockquote small:before {\n  content: \"\\2014 \\00A0\";\n}\n\nsmall {\n  font-size: 80%;\n}\n\nh1 {\n  font-size: 3em;\n  line-height: 1.15em;\n}\n\nh2 {\n  font-size: 2.4em;\n}\n\nh3 {\n  font-size: 1.825em;\n  line-height: 1.4em;\n  margin: 20px 0 10px;\n}\n\nh4 {\n  font-size: 1.3em;\n  line-height: 1.4em;\n}\n\nh5 {\n  font-size: 1.25em;\n  line-height: 1.4em;\n  margin-bottom: 15px;\n}\n\nh6 {\n  font-size: 1em;\n  text-transform: uppercase;\n  font-weight: 500;\n}\n\nbody {\n  background-color: #eeeeee;\n  color: #3c4858;\n}\n\nblockquote p {\n  font-style: italic;\n}\n\nbody,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 300;\n  line-height: 1.5em;\n}\n\na {\n  color: #9c27b0;\n  text-decoration: none;\n}\n\na:hover,\na:focus {\n  color: #89229b;\n  text-decoration: none;\n}\n\nlegend {\n  border-bottom: 0;\n}\n\n* {\n  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n  -webkit-tap-highlight-color: transparent;\n}\n\n*:focus {\n  outline: 0;\n}\n\na:focus,\na:active,\nbutton:active,\nbutton:focus,\nbutton:hover,\nbutton::-moz-focus-inner,\ninput[type=\"reset\"]::-moz-focus-inner,\ninput[type=\"button\"]::-moz-focus-inner,\ninput[type=\"submit\"]::-moz-focus-inner,\nselect::-moz-focus-inner,\ninput[type=\"file\"] > input[type=\"button\"]::-moz-focus-inner {\n  outline: 0 !important;\n}\n\nlegend {\n  margin-bottom: 20px;\n  font-size: 21px;\n}\n\noutput {\n  padding-top: 8px;\n  font-size: 14px;\n  line-height: 1.42857;\n}\n\nlabel {\n  font-size: 14px;\n  line-height: 1.42857;\n  color: #aaaaaa;\n  font-weight: 400;\n}\n\nfooter {\n  padding: 15px 0;\n}\n\nfooter ul {\n  margin-bottom: 0;\n  padding: 0;\n  list-style: none;\n}\n\nfooter ul li {\n  display: inline-block;\n}\n\nfooter ul li a {\n  color: inherit;\n  padding: 15px;\n  font-weight: 500;\n  font-size: 12px;\n  text-transform: uppercase;\n  border-radius: 3px;\n  text-decoration: none;\n  position: relative;\n  display: block;\n}\n\nfooter ul li a:hover {\n  text-decoration: none;\n}\n\n@media (max-width: 991px) {\n  body,\n  html {\n    position: relative;\n    overflow-x: hidden;\n  }\n\n  #bodyClick {\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    opacity: 0;\n    top: 0;\n    left: auto;\n    right: 260px;\n    content: \"\";\n    z-index: 9999;\n    overflow-x: hidden;\n  }\n}\n.fixed-plugin {\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 300;\n  line-height: 1.5em;\n  position: fixed;\n  top: 180px;\n  right: 0;\n  width: 64px;\n  background: rgba(0, 0, 0, 0.3);\n  z-index: 1031;\n  border-radius: 8px 0 0 8px;\n  text-align: center;\n  top: 120px;\n  .badge-primary-background-color: #9c27b0;\n}\n\n.fixed-plugin .SocialMediaShareButton,\n.fixed-plugin .github-btn {\n  display: inline-block;\n}\n\n.fixed-plugin li > a,\n.fixed-plugin .badge {\n  transition: all 0.34s;\n  -webkit-transition: all 0.34s;\n  -moz-transition: all 0.34s;\n  text-decoration: none;\n}\n\n.fixed-plugin .fa-cog {\n  color: #ffffff;\n  padding: 10px;\n  border-radius: 0 0 6px 6px;\n  width: auto;\n}\n\n.fixed-plugin .dropdown-menu {\n  right: 80px;\n  left: auto;\n  width: 290px;\n  border-radius: 0.1875rem;\n  padding: 0 10px;\n  position: absolute;\n  color: rgba(0, 0, 0, 0.87);\n  display: inline-block;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  background: #fff;\n  border-radius: 3px;\n}\n\n.fixed-plugin .fa-circle-thin {\n  color: #ffffff;\n}\n\n.fixed-plugin .active .fa-circle-thin {\n  color: #00bbff;\n}\n\n.fixed-plugin .dropdown-menu > .active > a,\n.fixed-plugin .dropdown-menu > .active > a:hover,\n.fixed-plugin .dropdown-menu > .active > a:focus {\n  color: #777777;\n  text-align: center;\n}\n\n.fixed-plugin img {\n  border-radius: 0;\n  width: 100%;\n  height: 100px;\n  margin: 0 auto;\n}\n\n.fixed-plugin .dropdown-menu li > a:hover,\n.fixed-plugin .dropdown-menu li > a:focus {\n  box-shadow: none;\n}\n.fixed-plugin .badge {\n  border: 3px solid #ffffff;\n  border-radius: 50%;\n  cursor: pointer;\n  display: inline-block;\n  height: 23px;\n  margin-right: 5px;\n  position: relative;\n  width: 23px;\n  background-color: rgba(30, 30, 30, 0.97);\n}\n\n.fixed-plugin .badge.active,\n.fixed-plugin .badge:hover {\n  border-color: #00bbff;\n}\n\n.fixed-plugin .badge-purple {\n  background-color: #9c27b0;\n}\n\n.fixed-plugin .badge-blue {\n  background-color: #00bcd4;\n}\n\n.fixed-plugin .badge-green {\n  background-color: #4caf50;\n}\n\n.fixed-plugin .badge-orange {\n  background-color: #ff9800;\n}\n\n.fixed-plugin .badge-red {\n  background-color: #f44336;\n}\n\n.fixed-plugin h5 {\n  font-size: 14px;\n  margin: 10px;\n}\n.fixed-plugin .dropdown-menu li {\n  display: block;\n  padding: 4px 0px;\n  width: 25%;\n  float: left;\n}\n\n.fixed-plugin li.adjustments-line,\n.fixed-plugin li.header-title,\n.fixed-plugin li.button-container {\n  width: 100%;\n  height: 50px;\n  min-height: inherit;\n  padding: 0px;\n  text-align: center;\n}\n\n.fixed-plugin li.adjustments-line p {\n  margin: 0;\n}\n\n.fixed-plugin li.adjustments-line div,\n.fixed-plugin li.header-title div,\n.fixed-plugin li.button-container div {\n  margin-bottom: 5px;\n}\n.fixed-plugin li.header-title {\n  height: 30px;\n  line-height: 25px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  text-transform: uppercase;\n}\n\n.fixed-plugin .adjustments-line p {\n  float: left;\n  display: inline-block;\n  margin-bottom: 0;\n  font-size: 1em;\n  color: #3c4858;\n}\n\n.fixed-plugin .adjustments-line a {\n  color: transparent;\n}\n\n.fixed-plugin .adjustments-line a .badge-colors {\n  position: relative;\n  top: -2px;\n}\n\n.fixed-plugin .adjustments-line a a:hover,\n.fixed-plugin .adjustments-line a a:focus {\n  color: transparent;\n}\n.fixed-plugin .adjustments-line .dropdown-menu > li.adjustments-line > a {\n  padding-right: 0;\n  padding-left: 0;\n  border-bottom: 1px solid #ddd;\n  border-radius: 0;\n  margin: 0;\n}\n\n.fixed-plugin .dropdown-menu > li > a.img-holder {\n  font-size: 16px;\n  text-align: center;\n  border-radius: 10px;\n  background-color: #fff;\n  border: 3px solid #fff;\n  padding-left: 0;\n  padding-right: 0;\n  opacity: 1;\n  cursor: pointer;\n  display: block;\n  max-height: 100px;\n  overflow: hidden;\n  padding: 0;\n}\n\n.fixed-plugin .dropdown-menu > li > a.img-holder img {\n  margin-top: auto;\n}\n.fixed-plugin .dropdown-menu > li:hover > a.img-holder,\n.fixed-plugin .dropdown-menu > li:focus > a.img-holder {\n  border-color: rgba(0, 187, 255, 0.53);\n}\n\n.fixed-plugin .dropdown-menu > .active > a.img-holder,\n.fixed-plugin .dropdown-menu > .active > a.img-holder {\n  border-color: #00bbff;\n  background-color: #ffffff;\n}\n.fixed-plugin .dropdown .dropdown-menu {\n  -webkit-transform: translateY(-15%);\n  -moz-transform: translateY(-15%);\n  -o-transform: translateY(-15%);\n  -ms-transform: translateY(-15%);\n  transform: translateY(-15%);\n  top: 27px;\n  opacity: 0;\n  transform-origin: 0 0;\n  display: none;\n}\n\n.fixed-plugin .dropdown .dropdown-menu:before {\n  border-bottom: 0.4em solid transparent;\n  border-left: 0.4em solid rgba(0, 0, 0, 0.2);\n  border-top: 0.4em solid transparent;\n  right: -16px;\n  top: 46px;\n}\n.fixed-plugin .dropdown .dropdown-menu:after {\n  border-bottom: 0.4em solid transparent;\n  border-left: 0.4em solid #ffffff;\n  border-top: 0.4em solid transparent;\n  right: -16px;\n}\n\n.fixed-plugin .dropdown .dropdown-menu:before,\n.fixed-plugin .dropdown .dropdown-menu:after {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  top: 46px;\n  width: 16px;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n}\n\n.fixed-plugin .dropdown.show .dropdown-menu {\n  display: block;\n  visibility: visible;\n  opacity: 1;\n  -webkit-transform: translateY(-13%);\n  -moz-transform: translateY(-13%);\n  -o-transform: translateY(-13%);\n  -ms-transform: translateY(-13%);\n  transform: translateY(-13%);\n  transform-origin: 0 0;\n}\n.fixed-plugin.rtl-fixed-plugin {\n  right: auto;\n  left: 0px;\n  border-radius: 0 8px 8px 0;\n}\n.fixed-plugin.rtl-fixed-plugin .dropdown-menu {\n  right: auto;\n  left: 80px;\n}\n* {\n  letter-spacing: normal !important;\n}\n\n\n.bgLoader{\n  background-color: rgba(254, 251, 251, .7);\n  position: absolute;\n  padding-top: 40px;\n  inset: 0 0 0 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
